import * as React from 'react';
import { connect } from 'react-redux';
import { EditorState } from 'draft-js';

import {
    MULTIMEDIA_TYPES,
    Project,
    Question,
    QuestionSummary
} from '@nexxt/common/types';
import { IApplicationState } from '../../../../../reducers';
import IncaVariableReferenceEditorModal from '../../../IncaVariable/IncaVariableReferenceEditorModal';

interface AnswerReferenceProps {
    question: Question;
    editorState: EditorState;
    onEditorChange: (editorState: EditorState) => void;
    showRandomize?: boolean;
    onClose?: () => void;
    isOpen?: boolean;
    answerReferenceQuestionValue?: string;
    toggleShowAnswerReference: (toggle: boolean) => void;
    showAnswerReference: boolean;
    selectedEntity?: { offsetKey: string; entityKey: string };
    addNewBubble?: (type: MULTIMEDIA_TYPES, data?) => void;
    deleteEntity?: (entityKey: string, offsetKey: string) => void;

    disabled: boolean;
    langName?: string;
}

/**
 * This component provides UI for researcher to create an IncaVariableReference.
 */
class AnswerReference extends React.Component<AnswerReferenceProps, any> {
    render() {
        return (
            <div className="answer--reference--container">
                <div
                    className="rdw-option-wrapper"
                    onClick={() => this.props.toggleShowAnswerReference(true)}
                >
                    ★ <span>Answer referencing</span>
                </div>
                {(this.props.showAnswerReference && (
                    <IncaVariableReferenceEditorModal
                        showAnswerReferenceModal={
                            this.props.showAnswerReference
                        }
                        answerReferenceQuestionValue={
                            this.props.answerReferenceQuestionValue
                        }
                        editorState={this.props.editorState}
                        selectedEntity={this.props.selectedEntity}
                        toggleShowAnswerReferenceModal={
                            this.props.toggleShowAnswerReference
                        }
                        onEditorChange={this.props.onEditorChange}
                        addNewBubble={this.props.addNewBubble}
                        disabled={this.props.disabled}
                        deleteEntity={this.props.deleteEntity}
                        langName={this.props.langName}
                    />
                )) ||
                    null}
            </div>
        );
    }
}

export default AnswerReference;
